import { QueryClient } from "@tanstack/react-query";

// Centralized QueryClient to avoid circular imports (App <-> AppState)
// and Temporal Dead Zone issues during early auth events.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes - data stays fresh
      gcTime: 1000 * 60 * 10, // 10 minutes - keep in memory
      refetchOnWindowFocus: false, // No refetch on tab switch
      refetchOnReconnect: false, // No refetch on network reconnect
      retry: 1, // Only 1 retry on failure
    },
  },
});
